import dynamic from 'next/dynamic';
import { type ReactNode, useState } from 'react';
import { TYPEFORM_DIALOG_CONTENT_CLASS } from '@/components/Typeform/embedDialog';
import { addGAEvent } from '@/utils/analytics/google/addGAEvent';
import { Button, Dialog, DialogContent, DialogTitle, DialogTrigger } from '@music-vine/cadence/ui';

// The public form ID from form.typeform.com/to/<id> — not the ULID the admin
// UI shows, which Typeform bounces to its marketing site.
const CUSTOM_LICENSING_TYPEFORM_ID = 'z4Wh2RTV';

// Loaded on first open only — keeps Typeform's script off the page load.
const TypeformWidget = dynamic(() => import('@typeform/embed-react').then(mod => mod.Widget), {
  ssr: false
});

/** Custom licensing enquiry banner + Typeform dialog (DEV-6398). */
export const CustomLicensingFormTrigger = ({
  content,
  eventValue,
  type
}: {
  content: string | ReactNode;
  eventValue: string;
  type: 'button' | 'link';
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenChange = (open: boolean) => {
    if (open) {
      addGAEvent('click-custom-licensing-talk-to-us', {
        category: 'custom-licensing',
        value: eventValue
      });
    }
    setIsOpen(open);
  };
  return <Dialog onOpenChange={handleOpenChange} open={isOpen} data-sentry-element="Dialog" data-sentry-component="CustomLicensingFormTrigger" data-sentry-source-file="CustomLicensingFormTrigger.tsx">
      <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-source-file="CustomLicensingFormTrigger.tsx">
        {type === 'button' ? <Button size="lg" variant="bold">
            {content}
          </Button> : <button type="button" className="!text-[#f7789f] underline">
            {content}
          </button>}
      </DialogTrigger>
      <DialogContent aria-describedby={undefined} className={TYPEFORM_DIALOG_CONTENT_CLASS} data-sentry-element="DialogContent" data-sentry-source-file="CustomLicensingFormTrigger.tsx">
        <DialogTitle className="sr-only" data-sentry-element="DialogTitle" data-sentry-source-file="CustomLicensingFormTrigger.tsx">Custom licensing enquiry</DialogTitle>
        {/* Without `inlineOnMobile` Typeform swaps the embed for its own
              fullscreen modal, which shows a bare form-name card (DEV-6631). */}
        <TypeformWidget className="size-full" id={CUSTOM_LICENSING_TYPEFORM_ID} inlineOnMobile data-sentry-element="TypeformWidget" data-sentry-source-file="CustomLicensingFormTrigger.tsx" />
      </DialogContent>
    </Dialog>;
};